import React, { useState } from "react";
import {
  Button,
  Image as AntdImage,
  Upload,
  Modal,
  notification,
  Alert,
  Space,
  Typography,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

import ImgCrop from "antd-img-crop";
import cropAndResizeToBase64 from "helpers/cropAndResizeToBase64";

const IconUpload = ({ upload, icon_url }) => {
  const [preview_image, setPreviewImage] = useState(null);
  const [delete_issue_image_id, setDeleteLogotype] = useState(null);

  const handleCustomUpload = async ({ file, onSuccess }) => {
    try {
      const base64 = await cropAndResizeToBase64(file, 50, 50);
      await upload({ icon: base64 });
      onSuccess("ok");
    } catch (error) {
      notification.error({ message: error });
    }
  };

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      notification.error({
        message: "Plik jest za duży",
        description: "Maksymalny rozmiar pliku to 5MB.",
      });
    }
    return isLt5M || Upload.LIST_IGNORE; // zablokuje dodanie pliku
  };

  const handlePreview = async (file) => setPreviewImage(file.url);

  const handleDelete = async () => {
    await upload({ icon: null });
    setDeleteLogotype(false);
  };

  return (
    <div className="m-t-20">
      {!!preview_image && (
        <AntdImage
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: true,
            onVisibleChange: () => setPreviewImage(null),
            afterOpenChange: (visible) => !visible && setPreviewImage(false),
          }}
          src={preview_image}
        />
      )}
      {delete_issue_image_id && (
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={true}
          onOk={handleDelete}
          onCancel={() => setDeleteLogotype(false)}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          Czy na pewno chcesz usunąć ikonę?
        </Modal>
      )}
      {!icon_url && (
        <Alert
        className="ant-alert-default"
          message={
            <Space direction="vertical">
              <Typography.Text>
                Dostępne formaty: <strong>png, jpeg, gif, webp</strong>
              </Typography.Text>
              <Typography.Text>
                Maksymalny rozmiar pliku: <strong>5 MB</strong>
              </Typography.Text>
            </Space>
          }
        />
      )}
      <ImgCrop
        modalTitle="Przytnij obraz"
        rotationSlider
        aspect={40 / 40}
        quality={1}
        showReset
        resetText="Resetuj"
      >
        <Upload
          onPreview={handlePreview}
          accept="image/jpeg,image/png,image/gif,image/webp"
          beforeUpload={beforeUpload}
          maxCount={1}
          customRequest={handleCustomUpload}
          fileList={
            icon_url
              ? [
                  {
                    uid: "-1",
                    name: "image.png",
                    status: "done",
                    url: icon_url,
                  },
                ]
              : []
          }
          listType="picture"
          onRemove={() => setDeleteLogotype(true)}
        >
          {!icon_url && (
            <Button
              className="m-t-20"
              type="primary"
              htmlType="button"
              icon={<UploadOutlined />}
            >
              Dodaj ikonkę
            </Button>
          )}
        </Upload>
      </ImgCrop>
    </div>
  );
};

export default IconUpload;
